<template>
  <div>
    <v-dialog v-model="customerSelect" max-width="600">
      <v-card>
        <v-card-title class="justify-center">{{ $t('customer.select_contractor_type') }}</v-card-title>
        <v-card-text class="py-5">
          <div class="grid grid-cols-2 gap-2">
            <div>
              <v-btn color="green" elevation="0" large dark block
                @click="selectCustomer(true, 'personal')">{{ $t('customer.type.personal') }}</v-btn>
            </div>
            <div>
              <v-btn color="blue" elevation="0" large dark block
                @click="selectCustomer(true, 'company')">{{ $t('customer.type.company') }}</v-btn>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="justify-center mx-2">
          <v-btn color="error" elevation="0" @click="customerSelect = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <form-customer v-model="isCustomerForm" :customerType="isCustomerType" event="create"
      @onCreated="emitDataCreate"></form-customer>
  </div>
</template>

<script>
import FormCustomer from "./FormCustomer.vue";
export default {
  components: { FormCustomer },
  name: "CustomerSelect",
  computed: {
    customerSelect: {
      get() {
        // if (this.value) {
        //   if (this.firstAction == 'personal') this.selectCustomer(true, 'personal')
        //   if (this.firstAction == 'company') this.selectCustomer(true, 'company')
        // }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      isCustomerForm: false,
      isCustomerType: "",
    };
  },
  props: {
    value: Boolean,
    emitData: Boolean,
    firstAction: {
      type: String,
      defalut: ''
    }
  },
  methods: {
    selectCustomer(status = true, select = "personal") {
      if (!this.emitData) {
        this.isCustomerType = select;
        this.isCustomerForm = status;
        if(this.isCustomerForm) this.customerSelect = false
      } else {
        this.$emit("onSelected", select);
      }
    },
    emitDataCreate(data) {
      this.$emit("onCreated", data);
    },
  },
};
</script>

<style lang="scss" scoped></style>
